import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLaravelnovaComponent } from './simple-icons-laravelnova.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLaravelnovaComponent ],
    exports:      [ SimpleIconsLaravelnovaComponent ],
    bootstrap:    []
})
export class SimpleIconsLaravelnovaModule {}
